import React, { memo } from 'react'
import { connect } from 'react-redux'
import { IGlobalMessage, IGlobalMessagingState } from 'types/globalMessaging'
import { hideMessage } from 'utils/actions/globalMessaging'
import { Message, IHideMessageHandler } from './components/Message'
import 'scss/5_components/_global-messaging.scss'

export interface IGlobalMessagingContainerData {
  message?: IGlobalMessage
}

export interface IGlobalMessagingContainerProps
  extends IGlobalMessagingContainerData,
    IHideMessageHandler {}

const GlobalMessagingContainer = memo<IGlobalMessagingContainerProps>(
  ({ hideMessage: hideMessageProp, message }) =>
    !message ? (
      <></>
    ) : (
      <div className='global-messaging-container' data-test='global-messaging'>
        <Message
          id={message.id}
          message={message.message}
          type={message.type}
          typeLabel={message.typeLabel}
          closeDelay={message.closeDelay}
          cta={message.cta}
          clickToCopyValue={message.clickToCopyValue}
          hideMessage={hideMessageProp}
        />
      </div>
    )
)

/**
 * @deprecated Use transfix-ui/components/Toast/GlobalToast instead
 */
export const GlobalMessaging = connect<
  IGlobalMessagingContainerData,
  IHideMessageHandler,
  {},
  { globalMessaging?: IGlobalMessagingState }
>(({ globalMessaging }) => ({ message: globalMessaging?.message }), {
  hideMessage,
})(GlobalMessagingContainer)

export default GlobalMessaging
